import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login');
          return;
        }

        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        updateUser(data);

        if (data.is_registered && data.is_paid) {
          navigate('/dashboard', { state: { user: data } });
        } else if (data.is_registered && !data.is_paid) {
          navigate('/payment', { state: { user: data } });
        } else {
          navigate('/register-details', { state: { user: data } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, updateUser]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-white text-lg">Completing login...</div>
    </div>
  );
};

export default AuthCallback;